import Vue from 'vue'
import {
  bus
} from '@/libs/bus'
import { utils } from "@/libs/utils";
import errors from '@/rules/errors'
import debug from 'debug'
var debug_pageCommon = debug("esma:page_common")
import _ from "lodash";
import moment from "moment";
import { resolve } from 'path';
import searchControl from "@/components/search_control";
import searchControlMaker from "@/components/search_control_maker";
import titleAndSearch from "@/components/title_and_search";
import titleAndSlot from "@/components/title_and_slot";
import confirmationModal from "@/components/modals/confirmation-modal";
import informationIconModal from '@/components/modals/information-icon-modal';
import constants from "@/rules/constants";
import async from "async";
import { type } from 'os';

export default {
  components: {
    "search-control": searchControl,
    "search-control-maker": searchControlMaker,
    "title-and-search": titleAndSearch,
    "title-and-slot": titleAndSlot,
    "confirmation-modal" :confirmationModal,
    'information-icon-modal':informationIconModal
  },
  created: function () {
    // debug_pageCommon('mixin page common loaded');
  },
  data() {
    return {
      row_data: [],
      data_values: {},
      data_values_original: {},
      selected_row: -1,
      last_notify_about_data_updated: 0,
      filter_list: [],
      filter_changed: false,
      forceSelectOnReturn: false,
      user_type: 0,
      read_only: true,
      total_number_of_rows:0,
      is_first_load:true,
      is_auto_sized:false,
      form_output_text:"帳票出力",
      form_output_qty:0,
      selected_row_arr: [],
      SELECTED_EMPTY_SELECT_BOX:"SELECTED_EMPTY_SELECT_BOX",
      user_entities_details:"",
      select_all_icon:"glyphicon glyphicon glyphicon-unchecked",
      is_all_selected :false,
      load_mode:"all",
      high_level_debug:{},
      validation_restriction_list:{},
      local_seq_id: -1,
      is_new :false,
      debug_show_page_name:false,
      local_page_container_size_reload:1,
      local_fields_ref:{},
      executing_filter_on_back:false
    }
  },

  computed: {
    isAdmin(){
      return Vue.localStorage.get("userRole")== constants.PERMISSION.CHIEF_ADMINISTRATOR || Vue.localStorage.get("userRole")== constants.PERMISSION.SYSTEM_ADMINISTRATOR || Vue.localStorage.get("userRole") == constants.PERMISSION.MAINTENANCE_STAFF;
    },
    isMultiCompanyAdmin(){
      // It is also used to allow multiple roles at users.
      var role = Vue.localStorage.get("userRole")
      return role == "保守担当" || role == "システム管理者";
    },
    isApproverAdminForApproveImport(){
      var role = Vue.localStorage.get("userRole")
      return role == "保守担当" || role == "システム管理者";
    },
    isApproverAdminForSimpleApprove(){
      var role = Vue.localStorage.get("userRole")
      return role == "保守担当" || role == "システム管理者";
    },
    isUserIDOperationInCharge(){
      var role = Vue.localStorage.get("userRole")
      return role == "ユーザIDオペレーション担当者";
    },
    isMaintenanceStaff(){
      var role = Vue.localStorage.get("userRole")
      return role == "保守担当";
    },
    isApproverUserId(){
      var role = Vue.localStorage.get("userRole")
      return role == "管理担当者" || role == "管理責任者";
    },
    isNoAdminUserId(){
      var role = Vue.localStorage.get("userRole")
      return role == "管理担当者" || role == "管理責任者";
    },
    selectedRowArr:{
      get(){
        return this.selected_row_arr;
      },
      set(v){
        this.selected_row_arr = v;
      }
    },
    batchEditText(){
      if(this.formOutputQty == 0){
        return "一括編集";
      }else{
        return "一括編集" + " ("+this.formOutputQty+")";
      }
    },
    disableIfCheckBoxNotSelected(){
      if(this.formOutputQty == 0 ){
        return true;
      }else{
        return false;
      }

    },
    formBatchEditDisabled(){
      if(this.formOutputQty == 0 ){
        return true;
      }
      if(this.disableButton('cancel') == false && this.disableButton('shusei') == true){
        return true;
      }
      return false;
    },
    formExportFileDisabled(){
      if(this.totalNumberOfRows == 0 ){
        return true;
      }
      return false;
    },
    stateCurrentRow(){
      if(typeof this.state_current_row != "undefined"){
        return this.state_current_row;
      }else{
        return "current_row";
      }
    },
    stateCurrentEditing(){
      if(typeof this.state_current_editing != "undefined"){
        return this.state_current_editing;
      }else{
        return "current_editing";
      }
    },
    stateIsEditingNew(){
      if(typeof this.state_is_editing_new != "undefined"){
        return this.state_is_editing_new;
      }else{
        return "is_editing_new";
      }
    },
    stateLastFilterOptions(){
      if(typeof this.state_last_filter_options != "undefined"){
        return this.state_last_filter_options;
      }else{
        return "last_filter_options";
      }
    },
    values() {
      return this.data_values;
    },
    filterList() {
      return this.filter_list;
    },
    readOnly:{
      get(){
        return this.read_only;
      },
      set(v){
        this.read_only = v;
      }
    },
    commonGridOptions(){
      return {
        defaultColDef: {
          editable: false
        },
        getRowNodeId: (data) => {
          return data.seq_id;
        },
        enableSorting: true,
        enableColResize: true,
        suppressMovableColumns: true,
        rowSelection: 'single',
        suppressHorizontalScroll: true,
        overlayNoRowsTemplate :"<span class=\"ag-overlay-loading-center\">対象のデータはありません</span>",
        overlayLoadingTemplate:"<span class=\"ag-overlay-loading-center\">Loading...</span>",
        onColumnResized: (ev, b) => {
        },
        onRowSelected: ev => {
          if(typeof this.onRowSelected != "undefined"){
            if (ev.node.isSelected()) {
              return this.onRowSelected(ev)
            }
          }
        },
        onModelUpdated: (ev, d) => {
        },
        onGridReady:() => {
        },
        getRowStyle: params => {
          if (params.node.data && (params.node.data.is_selected == true || this.isAllSelected == true)) {
            if(this.getRowStyleBackground){
              return { background: this.getRowStyleBackground };
            }else{
              return { background: "orange" };
            }
          }
      },
      };
    },
    defaultCreateColumn(){
      return  _.cloneDeep([
        {
          headerName: 'Seq', // sequence can be used to define the sequence of records
          field: 'seq_id',
          hide: true,
          sort: 'desc'
        },
         {
            headerName: "SearchControl",// Used to filter manually
            field: "search_control",
            hide: true
        },
        {
          headerName: "SearchFlowControl", // Used to filter manually
          field: "search_flow_control",
          hide: true,
        },
      ]);
    },
    validationRestrictionList:{
      get(){
        return this.validation_restriction_list;
      },
      set(v){
        this.validation_restriction_list = v;
      }
    },
    highLevelDebug:{
      get(){
        if(this.disableButton('toroku') == false){
          return [];
        }
        if(this.disableButton('shusei') == true && (this.selectedRowArr && this.selectedRowArr.length == 0)){
          return [];
        }
        var high_level_debug_enabled = localStorage.getItem("highLevelDebugEnabled")
        if(high_level_debug_enabled == "1"){
          return this.high_level_debug;
        }else{
          if(typeof high_level_debug_enabled == "undefined" || high_level_debug_enabled == null){
            localStorage.setItem("highLevelDebugEnabled","0")
          }
          return [];
        }
      },
      set(){}
    },
    selectAllIcon:{
      get(){
        return this.select_all_icon;
      },
      set(v){
        if(v == "checked"){
          this.select_all_icon = "glyphicon glyphicon glyphicon-check";
        }else if(v == "unchecked"){
          this.select_all_icon = "glyphicon glyphicon glyphicon-unchecked";
        }else{
          this.select_all_icon = "glyphicon glyphicon glyphicon glyphicon-edit";
        }
      }
    },
    isAllSelected:{
      get(){
        return this.is_all_selected;
      },
      set(v){
        this.is_all_selected = v;
      }
    },
    userEntitiesDetails:{
      get(){
        return this.user_entities_details;
      },
      set(v){
        this.user_entities_details = v;
      }
    },
    defaultPasscode(){
      if(this.userEntitiesDetails.indexOf("TB") > -1 || this.userEntitiesDetails.indexOf("MHTB") > -1){
        return "mizuho2016";
      }else if(this.userEntitiesDetails.indexOf("IR") > -1 || this.userEntitiesDetails.indexOf("MHIR") > -1){
        return "";
      }else{
        return "mizuho2006";
      }
    },
    formOutputText:{
      get(){
        if(this.formOutputQty > 0){
          return this.form_output_text + " ("+this.formOutputQty+")";
        }else{
          return this.form_output_text;
        }
      },
      set(v){
        this.form_output_text = v;
      }
    },
    formOutputQty:{
      get(){
        return this.form_output_qty;
      },
      set(v){
        this.form_output_qty = v;
      }
    },

    allFields(){
      var arr = [];

      if(typeof this.formFields != "undefined"){
        Object.keys(this.formFields).forEach(k =>{
          this.formFields[k].forEach(f =>{
            arr.push(f)
          })
        })
      }else if(typeof this.tabFieldList != "undefined"){
        this.tabFieldList.forEach(f =>{
          arr.push(f)
        })
      }

      return arr;
    },
    totalNumberOfRows:{
      get(){
        return this.total_number_of_rows;
      },
      set(v){
        this.total_number_of_rows = v;
      }
    },
    pageContainerSize:{
      get(){
        var s = (this.local_page_container_size_reload >-1)?localStorage.getItem("pageContainerSize"):false;
        if(s){
          return "container_" + s;
        }else{
          return "container_auto";
        }
      },
      set(v){
        this.local_page_container_size_reload ++;
      }
    },

    aclAllowBrowse() {
      return this.page_acl.browse.indexOf(this.user_type) > -1;
    },
    aclAllowAdd() {
      return this.page_acl.add.indexOf(this.user_type) > -1;
    },
    aclAllowEdit() {
      return this.page_acl.edit.indexOf(this.user_type) > -1;
    },
    aclAllowSave() {
      return this.page_acl.save.indexOf(this.user_type) > -1;
    },
    aclAllowDelete() { // Will be used at images
      return this.page_acl.delete.indexOf(this.user_type) > -1;
    },
    acl(){
      return utils.acl;
    },
    permissionMode(){
      return utils.PERMISSION_MODE;
    },
    installedFieldList(){
      var list = {}
      var arr = []
      var local_form_fields = this.formFields
      Object.keys(local_form_fields).forEach(k =>{
        var col = local_form_fields[k]
        col.forEach(f =>{
          list[f.id] = f
          arr.push(f)
        })
      })
      list.array = arr;
      return list;
    },
  },

  mounted() {
    this.user_type = parseInt(Vue.localStorage.get('userType'));
    bus.$on("on_insert_rule", (data) => {
      var rule = data.rule[0];//TODO: add support for multiple rules
      var value = data.value;
      if(rule.rule == "copy"){
        var obj = {};
        obj[rule.vkey] = value

        this.$ajax.post(rule.source_api, obj, (err, result) => {
          // Se result for false, eh porque nao existe.
          if(result){
            rule.fields.forEach(e=>{
              if(typeof result[e.from] != "undefined" && result[e.from] && _.get(result,[e.from],"").length > 0){
                debug_pageCommon("SETTING",this.$store.state[this.stateCurrentRow][e.to])
                bus.$emit(e.to,result[e.from])
              }
            })
          }
        });
      }else{
        console.log("on_insert_rule UNKNOWN rule ",rule)
      }
    })
    if(this.execute_filter_on_back == true){
      var lfo = this.$store.state[this.stateLastFilterOptions][this.api_name];
      this.executing_filter_on_back = false;
      if(lfo && typeof lfo != "undefined"){
        if(typeof lfo.filter != "undefined" && lfo.filter != false){
          this.$store.state.search_data = {};
          if(lfo.filter["1"] && lfo.filter["1"].value && lfo.filter["1"].value.length > 0){
            this.$store.state.search_data["1"] = lfo.filter["1"];
            this.executing_filter_on_back = true;
            setTimeout(()=>{
              bus.$emit("onOpenPageFilter",{field:lfo.filter["1"].field,val:lfo.filter["1"].value})
            },100)
          }
          if(lfo.filter["2"] && lfo.filter["2"].value && lfo.filter["2"].value.length > 0){
            this.$store.state.search_data["2"] = lfo.filter["2"];
            this.executing_filter_on_back = true;
            setTimeout(()=>{
              bus.$emit("onOpenPageFilter2",{field:lfo.filter["2"].field,val:lfo.filter["2"].value})
            },100)
          }
          if(lfo.filter["3"] && lfo.filter["3"].value && lfo.filter["3"].value.length > 0){
            this.$store.state.search_data["3"] = lfo.filter["3"];
            this.executing_filter_on_back = true;
            setTimeout(()=>{
              bus.$emit("onOpenPageFilter3",{field:lfo.filter["3"].field,val:lfo.filter["3"].value})
            },100)
          }
          if(lfo.filter["j1"] && lfo.filter["j1"] && lfo.filter["j1"].length > 0){
            this.$store.state.search_data["j1"] = lfo.filter["j1"];
            setTimeout(()=>{
              bus.$emit("onOpenPageFilterJoin1",lfo.filter["j1"])
            },100)
          }
          if(lfo.filter["j2"] && lfo.filter["j2"] && lfo.filter["j2"].length > 0){
            this.$store.state.search_data["j2"] = lfo.filter["j2"];
            setTimeout(()=>{
              bus.$emit("onOpenPageFilterJoin2",lfo.filter["j2"])
            },100)
          }

        }
        if(typeof lfo.sort != "undefined" && lfo.sort != false){
          //Work, but will be better if can set the icon in the bar
          this.last_data_source_sort = lfo.sort ;
        }
        if(typeof lfo.sort_key != "undefined" && lfo.sort_key != false){
          this.last_data_source_sort_key = lfo.sort_key ;
        }
      }
    }
  },

  beforeMount() {
    var userEntitiesDetails =  Vue.localStorage.get("userEntitiesDetails");
    if(userEntitiesDetails && userEntitiesDetails.length > 0){
      userEntitiesDetails = JSON.parse(userEntitiesDetails);
      this.userEntitiesDetails = userEntitiesDetails;
    }
  },
  beforeDestroy() {
    bus.$off("on_insert_rule");
    this.local_fields_ref = {};
    this.executing_filter_on_back = false;
  },
  methods: {
    loadSelectedApprovalHistory(name='selected_approval_history'){
      var selected_approval_history = Vue.localStorage.get(name) || []
      try {
        selected_approval_history = JSON.parse(selected_approval_history)
      } catch (error) {
        selected_approval_history = [];
      }
      if(Array.isArray(selected_approval_history) == false){
        selected_approval_history = [];
      }
      return selected_approval_history;
    },
    clearSearchFields(){
      // this.$store.state[this.stateLastFilterOptions][this.api_name] = null;
      bus.$emit("onSearchClear","");
    },
    commonAllChecked(alert_tag,cb=false){
      var limit = 100;
      setTimeout(() => {
        if(this.checkBoxSelectAll == false){
          this.gridOptions.api.forEachNode((node) => {
            if(this.hideCheckBox(node.data) == false){
              node.data.is_selected = false;
            }
          })
          if(cb){
            cb(null,0);
          }
        }else{
          if(this.totalNumberOfRows > 100){
            bus.$emit(alert_tag,{
              icon: "glyphicon glyphicon-alert",
              message: "1度に選択できるレコードは100件までです。<br>100件以上の処理を行う場合は先に選択済みの100件を処理した後、再度選択してください。",
              yes_label: "OK",
              yes_color:"danger",
              model_height:"50"
            });
            if(cb){
              cb(null,100);
            }
          }
          var count = 0;
          this.gridOptions.api.forEachNode((node) => {
            if(this.hideCheckBox(node.data) == false){
              if(limit > 0){
                count++;
                node.data.is_selected = true;
              }
              limit--;
            }
          })
          if(cb){
            cb(null,count);
          }
        }
        this.onReprocessIsSelectedClickDatasource({})
      }, 100);
    },
    getFieldLastValue(field_id,def=false){
      return this.$store.state[this.stateCurrentEditing][field_id] || this.$store.state[this.stateCurrentRow][field_id]|| def;
    },
    isMultiCompanyAdminByArray(array_or_roles){
      var ret = false;
      array_or_roles.forEach(role =>{
        if(role == "保守担当" || role == "システム管理者"){
          ret = true
        }
      })
      return ret;
    },
    isObject(val) {
      if (val === null || val === null) { 
        return false;
      }
      return ( typeof val === 'object' && Object.keys(val).length > 0 );
    },
    checkUserPermission(page_acl,permission,requester=""){
      if(page_acl == null || page_acl == true){
        page_acl = this.page_acl;
      }
      return utils.check_user_permission(page_acl,permission,requester)
    },

    hasHtmlClass(ele,cls) {
      return !!ele.className.match(new RegExp('(\\s|^)'+cls+'(\\s|$)'));
    },
    addHtmlClass(ele,cls) {
      if (!this.hasHtmlClass(ele,cls)) ele.className += " "+cls;
    },
    removeHtmlClass(ele,cls) {
      if (this.hasHtmlClass(ele,cls)) {
        var reg = new RegExp('(\\s|^)'+cls+'(\\s|$)');
        ele.className=ele.className.replace(reg,' ');
      }
    },
    singleSearchCreate(field,val,type="input"){
      return {
        1:{
          block: "1", 
          field: field, 
          value: val, 
          ct: "v", 
          ca: false, 
          t: type,
          exact_value:true
        },
        2: false,
        3: false,
        b2_disabled: false,
        b3_disabled: true,
        j1: "AND",
        j2: "AND",
      };
    },
    doubleAndSearchCreate(field1,val1,field2,val2,type1="input",type2="input"){
      return {
        1:{
          block: "1",
          field: field1,
          value: val1,
          ct: "v",
          ca: false,
          t: type1,
          exact_value:true
        },
        2: {
          block: "2",
          field: field2,
          value: val2,
          ct: "v",
          ca: false,
          t: type2,
          exact_value:true
        },
        3: false,
        b2_disabled: false,
        b3_disabled: true,
        j1: "AND",
        j2: "AND",
      };
    },
    commonCreateColumnDefs({show_details,show_checkbox,field_list_name,force_sort=false}){
      var arr = _.clone(this.defaultCreateColumn);
      if(force_sort != false){
        arr.forEach(e=>{
          delete e.sort;
        })
      }
      var i = 0;
      if(typeof field_list_name == "undefined"){
        field_list_name = "tabFieldList";
      }
      this[field_list_name].forEach((f) => {
        var fi = {
          headerName: f.tab_label,
          field: f.id,
          width: f.tab_size || 40,
          tooltipField: f.id
        };
        if(f.suppressSorting == true){
          fi.suppressSorting = true;
        }
        if(force_sort != false){
          if(force_sort.id == fi.field){
            fi.sort = force_sort.direction;
            this.last_data_source_sort = [{
              colId:fi.field,
              sort:force_sort.direction
            }]
          }
        }
        if(f.type == "date_picker"  ){
          fi.cellRenderer = (params) =>{
              return utils.format_date(params.value);
          }
        }else if(f.type == "select" ){
          fi.cellRenderer = (params) =>{
            if(f.table_field_style && _.size(f.table_field_style ) > 0){
              return "<span style='"+f.table_field_style[params.value]+"'>" +params.value +"</span>" ;
            }else{
              return params.value;
            }
          }
        }else if(f.type == "select2"){
          fi.cellRenderer = (params) =>{
            var found = _.find(f.options,(d)=>{return params.value == d.value})
            var ret = ""
            if(found && typeof found != "undefined"){
              ret =  found.label;
            }else{
              ret =  params.value;
            }
            if(f.table_field_style && _.size(f.table_field_style ) > 0 && typeof f.table_field_style[params.value] != "undefined"){
              return "<span style='"+f.table_field_style[params.value]+"'>" +ret +"</span>" ;
            }else{
              return ret;
            }
          }
        }else if(f.type == "select4" && typeof f.api_tab_label != "undefined"){
          fi.cellRenderer = (params) =>{
            if(typeof f.api_complement_array != "undefined" && Array.isArray(f.api_complement_array)){
              var found = _.find(f.api_complement_array,(d)=>{return params.value == d[f.api_field_name]})
              if(found && found[f.api_tab_label]){
                return found[f.api_tab_label];
              }
            }
            return _.get(params,"data."+f.api_tab_label,params.value) || params.value;
          }
        }else if(f.type == "datetime_picker" || f.type == "date_picker" || f.type == "current_time"){
          fi.cellRenderer = (params) =>{
              return utils.format_date_time(params.value);
          }
        }else if(f.cellRenderer){
          fi.cellRenderer = f.cellRenderer;
        }
        if(this.cellStyle){
          fi.cellStyle = this.cellStyle
        }
        arr.push(fi);
      });
      var extra_fields = [];
      if(show_details == true){
        extra_fields.push(this.fieldList.more_details)
      }
      if(show_checkbox == true){
        extra_fields.push(this.fieldList.button_options)
      }

      extra_fields.forEach(f => {
        var fi = {
          headerName: f.tab_label,
          sortable: false,
          field: f.id,
          width: 50,
          maxWidth: 50,
          pinned: 'right',
          cellRenderer: params => {
            if ( params.column.colId == "more_details") {
              return this.createGridTextButton(
                this.show_details_label || "詳細",
                "color: #5b9bd5;",
                this.onDetailsClick,
                params.data
              );
            }
            if (params.column.colId == "button_options") {
              if(this.hideCheckBox){
                if(this.hideCheckBox(params.data) == true){
                  return ""
                }
              }
              return this.createGridButton(
                "glyphicon glyphicon glyphicon-unchecked",
                "color: #5b9bd5;",
                (ev, selected_row)=>{
                  if(this.hideCheckBox){
                    if(this.hideCheckBox(params.data) == true){
                      return ;
                    }
                  }
                  this.onSelectedClickDatasource(ev, selected_row)
                },
                params.data
              );
            }
          }
        };
        arr.push(fi);
      });
      return arr;
    },
    validationRestriction(data){
        this.validationRestrictionList[data.id] = data;
    },
    setHighLevelDebug(key,label,text){
      this.highLevelDebug[key] = {label,text}
    },
    cleanHighLevelDebug(key){
      delete this.highLevelDebug[key] 
    },
    cleanAllHighLevelDebug(){
      this.highLevelDebug = {}
    },
    customSort(valueA, valueB, nodeA, nodeB, isInverted) {
      // It can not be used, because wen move to Mysql, it will not work.
      if(isNaN(valueA) == false && isNaN(valueB) == false ){
        return parseInt(valueA) > parseInt(valueB)?1:-1;
      }
      else{
          return ('' + valueA).localeCompare(valueB, {numeric: true, sensitivity: 'base'});
      }
  },
    searchControlChanged(d){
      if(this.clearSelections){
        this.clearSelections();
      }

      /**
       * Need to add search_control to createColumnDefs
       * And change tables (tab_***) to return all.
       * And fix the clear button position
       */
      var filter_count = 0;
      var proc1 =false;
      var proc2 =false;
      var proc3 =false;
      if(d[1] != false && d[1].value && d[1].value != ""){
        filter_count++;
        proc1 = true;
      }
      if(d.b2_disabled== false && d[2] != false && d[2].value && d[2].value != ""){
        filter_count++;
        proc2 = true;
      }
      if(d.b3_disabled== false && d[3] != false && d[3].value && d[3].value != ""){
        filter_count++;
        proc3 = true;
      }
      // console.log("searchControlChanged",d,this.row_data,d[1]);
      //onFiltering
      // Maybe will need to do a custom filter engine.
      // Add a col, searchFiltered = true,
      // when search, set all to false.
      // Then apply the filter in memory and set searchFiltered = true.
      var R_INIT = 0;
      var R_FOUND = 1;
      var R_NOT_FOUND = 3;
      var d_j1 = d.j1;
      var d_j2 = d.j2;
      if(filter_count > 0){

        if(d.b2_disabled == true){
          d_j1 = "DISABLED";
        }
        if(d.b3_disabled == true){
          d_j2 = "DISABLED";
        }
        this.gridOptions.api.forEachNode((node) => {
          var found = false;
          var foundA = false;
          var foundB = false;
          var found1 = R_INIT;
          var found2 = R_INIT;
          var found3 = R_INIT;

          if(proc1){
            if(node.data[d[1].field]){
              if(d[1].t != "select" && node.data[d[1].field].indexOf(d[1].value) > -1 ){
                found1 = R_FOUND;
              }else if(d[1].t == "select" && node.data[d[1].field] == d[1].value){
                  found1 = R_FOUND;
              }else{
                found1 = R_NOT_FOUND;
              }
            }else if(d[1].value == this.SELECTED_EMPTY_SELECT_BOX && ( node.data[d[1].field] == "" || node.data[d[1].field] == null || node.data[d[1].field] == false )){
                found1 = R_FOUND;
            }
          }
          if(proc2){
            if(node.data[d[2].field]){
              //   found2 = R_FOUND;
              if(d[2].t != "select" && node.data[d[2].field].indexOf(d[2].value) > -1 ){
                found2 = R_FOUND;
              }else if(d[2].t == "select" && node.data[d[2].field] == d[2].value){
                  found2 = R_FOUND;
              }else{
                found2 = R_NOT_FOUND;
              }
            }else if(d[2].value == this.SELECTED_EMPTY_SELECT_BOX && ( node.data[d[2].field] == "" || node.data[d[2].field] == null || node.data[d[2].field] == false )){
              found2 = R_FOUND;
            }
          }
          if(proc3){
            if(node.data[d[3].field]){
              //   found3 = R_FOUND;
              if(d[3].t != "select" && node.data[d[3].field].indexOf(d[3].value) > -1 ){
                found3 = R_FOUND;
              }else if(d[3].t == "select" && node.data[d[3].field] == d[3].value){
                found3 = R_FOUND;
              }else{
                found3 = R_NOT_FOUND;
              }
            }else if(d[3].value == this.SELECTED_EMPTY_SELECT_BOX && ( node.data[d[3].field] == "" || node.data[d[3].field] == null || node.data[d[3].field] == false )){
              found3 = R_FOUND;
            }
          }
          /**
           * 
           * (F and F) and F
           * (F and F) or F
           * (F or F) and F
           * (F or F) or F
           */
          // Only one field
          if(proc2 == false && proc3 == false){
            found  = found1 == R_FOUND;
          }

          if(proc2 == true && d_j1 != "DISABLED"){
            if(d_j1 =="AND"){
              if(found1 != R_INIT && found2 != R_INIT){
                foundA  = found1 == R_FOUND && found2 == R_FOUND;
              }
            }else if(d_j1 =="OR"){
              if(found1 != R_INIT || found2 != R_INIT){
                foundA  = found1 == R_FOUND || found2 == R_FOUND;
              }
            }
            found = foundA;
          }
          if(proc3 == true && d_j2 != "DISABLED"){
            if(d_j2 =="AND"){
              if(found2 != R_INIT && found3 != R_INIT ){
                foundB  =  found3 == R_FOUND && foundA == true;
              }
            }else if(d_j2 =="OR"){
              if(foundA == true){
                // it is already true, so is OK
                foundB = true;
              }else{
                if(found3 != R_INIT){
                  foundB  =  found3 == R_FOUND;
                }
              }
            }
            found = foundB;
          }

          if(typeof node != "undefined" && typeof node.data != "undefined" ){
            node.data.search_control = found;
          }
        })
      }else{
        // Show all
        console.log("Will not filter")
        this.gridOptions.api.forEachNode((node) => {
          if(typeof node != "undefined" && typeof node.data != "undefined"  ){
              node.data.search_control = true;
          }
        });
      }
      this.applyFilterOnSearchControl();

    },
    applyFilterOnSearchControl(){
      var filterComponent = this.gridOptions.api.getFilterInstance("search_control");
      if(typeof filterComponent == "undefined"){
        return;
      }
      var model = filterComponent.getModel();
      filterComponent.setModel({type: 'equals',filter: true});
      filterComponent.onFilterChanged()
    },
    autoSizeAll(force=false) {
      if(this.is_auto_sized == false || force == true){
        this.is_auto_sized = true;
        var allColumnIds = [];
        this.gridOptions.columnApi.getAllColumns().forEach(function(column) {
          if(column.visible && column.colId != "more_details" && column.colId != "button_options"){
            allColumnIds.push(column.colId);
          }
        });
        console.log("autoSizeAll do")
        this.gridOptions.columnApi.autoSizeColumns(allColumnIds);
      }
    },
    checkForFilters(){
      if(this.is_first_load){
        this.is_first_load = false;
      }
    },
    listOfFields() {
      var list = []
      this.formFieldsCol1.forEach((d) => {
        list.push(d)
      });
      this.formFieldsCol2.forEach((d) => {
        list.push(d)
      });
      this.formFieldsCol3.forEach((d) => {
        list.push(d)
      });
      if(this.formFieldsCol4){
        this.formFieldsCol4.forEach((d) => {
          list.push(d)
        });
      }
      return list
    },
    checkRequiredFields(fields, required_fields) {
      debug_pageCommon("checkRequiredFields",fields,required_fields);
      var ready = true;
      if (this.$store.state[this.stateIsEditingNew] == true) {
        if(required_fields){
          required_fields.forEach((f) => {
            if (typeof this.$store.state[this.stateCurrentEditing][f] == "undefined") {
              debug_pageCommon("checkRequiredFields failed",f);
              this.$notify({
                title: "登録を行うためには、「" + fields[f].label + "」の入力が必要です",
                type: "error",
                duration: 5000
              });
              ready = false;
            }
          });
        }
      }
      return ready;
    },
    btnAddNew(ignore = [],new_vals=false) {
      this.validationRestrictionList = {};
      this.$store.state[this.stateIsEditingNew] = true;
      this.$store.state[this.stateCurrentRow] = {}
      this.$store.state[this.stateCurrentEditing] = {}
      this.listOfFields().forEach((d) => {
        if (ignore.indexOf(d.id) < 0) {
          debug_pageCommon("btnAddNew", d.id)
          this.$store.state[this.stateCurrentRow][d.id] = "";
          delete this.$store.state[this.stateCurrentEditing][d.id]
        }
        if(d.id == "entity"){
          var userEntitiesDetails =  Vue.localStorage.get("userEntitiesDetails");
          if(userEntitiesDetails && userEntitiesDetails.length > 0){
            userEntitiesDetails = JSON.parse(userEntitiesDetails);
          }
          this.$store.state[this.stateCurrentRow][d.id] =  userEntitiesDetails[0]||"";
          this.$store.state[this.stateCurrentEditing][d.id] =  userEntitiesDetails[0]||"";
        }

      });
      this.$store.state[this.stateCurrentRow]["seq_id"] = Number.MAX_SAFE_INTEGER;
      if(new_vals != false){
        Object.keys(new_vals).forEach((k)=>{
          this.$store.state[this.stateCurrentRow][k] = new_vals[k];
          this.$store.state[this.stateCurrentEditing][k] = new_vals[k];
        })
      }
      this.btnSetReadOnly(false)
      this.selected_row = Number.MAX_SAFE_INTEGER
    },
    btnEditBatch(allow_only=[]) {
      this.$store.state[this.stateIsEditingNew] = true;
      this.$store.state.is_editing_batch = true;
      this.$store.state[this.stateCurrentRow] = {}
      this.listOfFields().forEach((d) => {
        if (allow_only.indexOf(d.id) > -1) {
          debug_pageCommon("btnAddNew", d.id)
          this.$store.state[this.stateCurrentRow][d.id] = "";
          delete this.$store.state[this.stateCurrentEditing][d.id]
        }
      });
      this.$store.state[this.stateCurrentRow]["seq_id"] = Number.MAX_SAFE_INTEGER - 10;
      this.btnSetReadOnly(false)
      this.selected_row = Number.MAX_SAFE_INTEGER - 10;

    },
    disableButton(name) {

      switch (name) {
        case "tsuika":
          if (!this.aclAllowAdd) {
            return true;
          }
          return this.readOnly == false;// || this.selected_row != -1;
          break;
        case "shusei":
          if (!this.aclAllowEdit) {
            return true;
          }
          return this.selected_row == -1 || this.readOnly == false;
          break;
        case "toroku":
          if (!this.aclAllowSave) {
            return true;
          }
          return this.selected_row == -1 || this.readOnly == true;
          break;
        case "delete":
          if (!this.aclAllowSave) {
            return true;
          }
          return this.selected_row == Number.MAX_SAFE_INTEGER || this.selected_row == (Number.MAX_SAFE_INTEGER  - 10) || this.selected_row == -1 || this.readOnly == true;
          break;
        case "cancel":
          return this.selected_row == -1;
          break;
        default:
          return false;
          break;
      }
    },
    btnSetReadOnly(mode) {
      this.read_only = mode;
    },
    createGridButton(icon, style, onClick, row_data) {
      var center = document.createElement('center');
      var btn = document.createElement('button');
      // btn.style.cssText="background:red;"
      btn.className = "btn btn-link btn-xs"
      btn.innerHTML = '<center><span class="' + icon + '" style="' + style + '" aria-hidden="true"></span></center>';
      btn.addEventListener('click', (ev) => {
        onClick(ev, row_data)
      });
      center.appendChild(btn)
      return center;
    },
    createGridTextButton(text, style, onClick, row_data) {
      var center = document.createElement('center');
      var btn = document.createElement('button');
      // btn.style.cssText="background:red;"
      btn.className = "btn btn-link btn-xs"
      btn.innerHTML = '<center><span style="' + style + '" aria-hidden="true">'+text+'</span></center>';
      btn.addEventListener('click', (ev) => {
        onClick(ev, row_data)
      });
      center.appendChild(btn)
      return center;
    },
    selectSeqId(seq_id, retry) {
      setTimeout(() => {
        var found = false;
        this.gridOptions.api.refreshView();
        this.gridOptions.api.forEachNode((node) => {
          if (node.data && node.data.seq_id == seq_id) {
            found = true;
            this.gridOptions.api.ensureIndexVisible(node.childIndex);
            this.gridOptions.api.selectNode(node, true);
            node.setSelected(true);
          }
        });
        if (found == false) {
          if (retry > 0) {
            this.selectSeqId(seq_id, retry - 1)
          }

        }
      }, 50);
    },
    refreshNewRow(result,mode) {
      this.$store.state[this.stateIsEditingNew] = false;
      if(this.load_mode =="all"){
        this.row_data.push(result);
        this.gridOptions.api.refreshView();
        this.selectSeqId(result.seq_id, 3)
      }else{
        this.refreshNewRowDatasource(result,mode);

      }
    },
    refreshDeletedRow(id) {
      this.$store.state[this.stateIsEditingNew] = false;
      debug_pageCommon("refreshDeletedRow", id)

      var selectedData = this.gridOptions.api.getSelectedRows();
      this.cancelCurrentSelection(false);
      var res = this.gridOptions.api.updateRowData({remove: selectedData});

      var removed = _.remove(this.row_data,{seq_id:id})
      var found = _.find(this.row_data,{seq_id:id})

      debug_pageCommon("refreshDeletedRow removed", removed,"found",found, "res",res)

      this.gridOptions.api.refreshView();
    },
    refreshRow(result, show_diff = false) {
      debug_pageCommon("refreshRow", result, show_diff)
      this.$store.state[this.stateIsEditingNew] = false;
      var diff = [];

      if(this.load_mode =="all"){
        var len = this.row_data.length
        for (var i = 0; i < len; i++) {
          if (this.row_data[i].seq_id == result.seq_id) {
            for (var key in result) {
              if (result[key] != this.row_data[i][key]) {
                if (show_diff) {
                  diff.push(key)
                }
                this.row_data[i][key] = result[key]
              }
            }
          }
        }

      }else{
        /**
         * Support the update for datasource mode
         */
        this.gridOptions.api.forEachNode((node) => {
          if(node.data && node.data.seq_id== result.seq_id){
            for (var key in result) {
              if (result[key] != node.data[key]) {
                if (show_diff) {
                  diff.push(key)
                }
                node.data[key] = result[key]
              }
            }
          }
        })
      }
      this.data_values_original = result
      this.$store.state[this.stateCurrentRow] = result

      this.data_values = result

      this.gridOptions.api.refreshView();
      if (show_diff) {
        return diff;
      }
    },
    cancelCurrentSelectEdition(showCanceledToast=false) {

      this.gridOptions.suppressRowClickSelection = false;
      this.$store.state[this.stateIsEditingNew] = false;
      this.read_only = true;
          if (showCanceledToast) {
            this.$notify({
              title: 'キャンセルしました',
              type: 'info',
              duration: 1000
            });
          }
    },
    cancelCurrentSelection(showCanceledToast=false) {
      this.validationRestrictionList = {};
      // var reselect_row = false
      // if(this.selected_row != -1 && this.readOnly == false && this.selected_row != Number.MAX_SAFE_INTEGER){
      //   // If is editing call this to cancel, but still with line selected.
      //   return this.cancelCurrentSelectEdition(showCanceledToast);
      // }
      this.$store.state[this.stateIsEditingNew] = false;
      this.selected_row = -1 
      this.read_only = true;
      if(!(this.gridOptions && this.gridOptions.api)){
        return;
      }
      this.gridOptions.api.forEachNode((node) => {
        if (node.isSelected()) {
          node.setSelected(false)
          for(var key in this.$store.state[this.stateCurrentRow]){
            this.$store.state[this.stateCurrentRow][key] = "";
          }
          this.$store.state[this.stateCurrentRow] = {}
          if (showCanceledToast) {
            this.$notify({
              title: 'キャンセルしました',
              type: 'info',
              duration: 1000
            });
          }
        }
      });
    },
    cleanUpForm(vm) {
      vm.$store.state[vm.stateCurrentEditing] = [];
      vm.data_values = {};
    },
    commonOnRowSelected: (vm, ev, mode, cb=()=>{}) => {
      vm.validationRestrictionList = {};
      debug_pageCommon("common OnRowSelected",vm.lock_grid)
      if(vm.lock_grid == true){
        return false
      }
      if (ev.node && ev.node.isSelected() && ev.node.data) {
        vm.cleanUpForm(vm)
        vm.$store.state[this.stateIsEditingNew] = false;
        vm.$ajax.post('/' + mode + '/get/' + ev.node.data.seq_id, {}, (err, result) => {
          if (err) {
            if (err == "Not logged") {
              vm.$notify({
                title: 'セッションの有効期限が切れましたので、もう一度ログインを行ってください', //  'Login expired, you need to login again.'
                type: 'error',
                duration: 10000
              });
            } else {
              vm.$notify({
                title: 'データの読込に失敗しました。',
                type: 'error',
                duration: 10000
              });
            }

          } else {
            vm.data_values = result.data
            vm.data_values_original = result.data
            vm.$store.state[vm.stateCurrentRow] = result.data
            vm.selected_row = result.data.seq_id
            vm.btnSetReadOnly(true)
            return cb(vm);
          }
        })
      }
    },
    saveBulk(api_name, seq_id_list, options = {}, cb){
      var new_vals  = {};
      Object.keys(this.fieldList).forEach((k=>{
        if(this.$store.state[this.stateCurrentEditing][k]  && ("" + this.$store.state[this.stateCurrentEditing][k]).length > 0){
          new_vals[k] = this.$store.state[this.stateCurrentEditing][k];
        }
      }));
      if(options && Array.isArray(options.disabled_fields) && options.disabled_fields.length > 0){
        options.disabled_fields.forEach(k=>{
          delete new_vals[k];
        })
      }
      this.$ajax.post('/'+api_name+'/save_bulk/', {
        changes:new_vals,
        seq_id_list: seq_id_list,
        from_edit_form: options.from_edit_form || false
      }, (err, result, error_code) => {
        console.log("saveBulk ERROR",{err, result, error_code})
        this.$notify({clear:true});
        if(err){
          this.$notify({clean:true});
          var title = "予期しないエラーが発生し、登録が行えません";
          if(err && err.indexOf("::") == 0){
            title = err.replace("::","");
            err = ""
          }
          this.$notify({clean: true});
          var obj = {
            title: title,
            text:err,
            type: 'error',
            duration: 10000
          }
          this.$notify(obj);
          return cb(err);
        }else{
          this.$notify({
            title: '保存しました!',
            type: 'success',
            duration: 2000
          });
          return cb(null);
        }
      });

    },
    commonEditDeleteCmdHandler:(vm,cb=()=>{}) =>{
      if(vm.$route && vm.$route.params){
        if(vm.$route.params.cmd =="edit"){
          setTimeout(() => {
            vm.read_only = false;
            cb();
          }, 300);
        }else if(vm.$route.params.cmd =="delete"){
          setTimeout(() => {
            vm.onDelete();
            cb();
          }, 100);
        }else{
          cb();
        }
        console.log("CMD IN",vm.$route.params.cmd)
      }else{
        cb();
      }
    },
    commonLoadRecord(options, cb=()=>{}){
      if(this.$route.params.seq_id == "new" || options.force_seq_id == "new"){
        this.local_seq_id = Number.MAX_SAFE_INTEGER;
        this.$store.state[this.stateCurrentRow] = {
          seq_id : this.local_seq_id
        }
        this.allFields.forEach(f =>{
          this.$store.state[this.stateCurrentRow][f.id] = "";
        })
        setTimeout(() => {
          this.$store.state[this.stateIsEditingNew] = true;
          this.read_only = false;
          this.is_new = true;
        }, 300);
        debug_pageCommon("mounted as new")
        return cb(null,{})
      } else {
        this.is_new = false;
        this.local_seq_id = options.force_seq_id  || this.$route.params.seq_id;
        if(typeof this.local_seq_id == "undefined"){
          console.error('UNEXPECTED REQUEST TO URL: ','/' + this.api_name + '/get/' + this.local_seq_id);
          console.trace('UNEXPECTED REQUEST TO URL: ','/' + this.api_name + '/get/' + this.local_seq_id);
        }
        this.$ajax.post('/' + this.api_name + '/get/' + this.local_seq_id, {}, (err, result) => {
          if(err){
            this.$notify({
              title: 'データの読込に失敗しました。',
              text: err,
              type: 'error',
              duration: 10000
            });
          }else if( this.isObject(result) == false){
            this.$notify({
              title: 'データの読込に失敗しました。',
              text: "Returned empty data",
              type: 'error',
              duration: 10000
            });
          }
          this.$store.state[this.stateCurrentRow] = result.data;

          this.commonSetStyleForChangedFields(result.data);

          debug_pageCommon("LOAD DATA RECORD",{err, result});
          return cb(err,result)
        })
      }
    },
    commonSetStyleForChangedFields(data){
      if(typeof data["last_changed_fields"] == "string" && data["last_changed_fields"].length > 0){
        var last_changed_fields = data["last_changed_fields"].split(",");
        var store_key_name = this.stateCurrentRow.replace("current_row","current_field_style")
        // It should be done at each page, as there are own rules that should be implemented
        this.processFieldStyle(store_key_name,last_changed_fields);
      }
    },
    commonOnEdit(){
      this.$store.state[this.stateCurrentEditing] = {};
      setTimeout(() => {
        this.read_only = false;
      }, 300);
    },
    commonValidateFieldsClear(vm,cb){
      var working_field_list = vm.fieldList;
      if(vm.installedFieldList){
        working_field_list = vm.installedFieldList;
      }
      working_field_list.array.forEach(f =>{
        if(f.error_if_blank == true){
          working_field_list[f.id].on_field_messages(vm,{msg_type:"error",show_as_error_mode:false},()=>{})
        }
      })
      cb();
    },
    commonValidateFields(vm,options,cb){

      if(this.fields_validation_is_disabled == true){
        return cb(false);
      }
      var ignoreFieldValidation = Vue.localStorage.get("forceIgnoreFieldValidation") || 0;
      if(ignoreFieldValidation == "12349856"){
        return cb(false)
      }
      var pre_defined_errors = []
      if(options && options.pre_defined_errors && options.pre_defined_errors.length > 0){
        pre_defined_errors = options.pre_defined_errors
      }
      var working_field_list = vm.fieldList;
      if(vm.installedFieldList){
        working_field_list = vm.installedFieldList;
      }else{
      }
      var seq_id = vm.$store.state[vm.stateCurrentRow].seq_id;
      var is_editing = false;
      if(seq_id != Number.MAX_SAFE_INTEGER && seq_id != "new"){
        is_editing = true;
      }
      var array_err = []
        // Validate fields
        async.mapLimit(working_field_list.array, 1, (f, done) => {

          // Validate blank
          if(f.error_if_blank == true ){
            var val = vm.$store.state[vm.stateCurrentEditing][f.id] || vm.$store.state[vm.stateCurrentRow][f.id];
            if(is_editing){
              val = vm.$store.state[vm.stateCurrentEditing][f.id];
              if(typeof val == "undefined"){
                val = vm.$store.state[vm.stateCurrentRow][f.id];
              }
            }
            if(f.type == "email"){
              if(utils.if_null(val) == ""){
              }else if(val.indexOf("@") < 0){
                val = "";
              }else if(val.split("@").length != 2){
                val = "";
              }else if(utils.if_null(val.split("@")[0]) == ""){
                val = "";
              }else if(utils.if_null(val.split("@")[1]) == ""){
                val = "";
              }
            }
            if(f.type == "input" && f.field_type == "number" ){
              if(f.type == "input" && f.field_type == "number" && isNaN(val)){
                val = ""
              }else if(f.type == "input" && f.field_type == "number" && typeof f.min_value != "undefined"){
                if(parseInt(val) < parseInt(f.min_value)){
                  val = ""
                }
              }
            }

            if(utils.if_null(val) == "" && typeof val != "number"){
              if(working_field_list[f.id].on_field_messages){
                working_field_list[f.id].on_field_messages(vm,{msg_type:"error",show_as_error_mode:true, only_if_enabled:true},(show)=>{
                  if(show){
                    array_err.push({field:f,type:"blank"});
                  }
                  done()
                })
              }else{
                array_err.push({field:f,type:"blank"});
                done()
              }

            }else{
              if(working_field_list[f.id].on_field_messages){
                working_field_list[f.id].on_field_messages(vm,{msg_type:"error",show_as_error_mode:false},()=>{
                  done()
                })
              }else{
                done()
              }
            }
          }else{
            if(working_field_list[f.id].on_field_messages){
              working_field_list[f.id].on_field_messages(vm,{msg_type:"error",show_as_error_mode:false},()=>{
                done()
              })
            }else{
              done()
            }
          }
        }, (err, allDone) => {
          vm.$notify({clean:true});
          if(pre_defined_errors.length > 0){
            pre_defined_errors.forEach(f=>{
              if(working_field_list[f.id].on_field_messages){
                working_field_list[f.id].on_field_messages(vm,{msg_type:"error",show_as_error_mode:true, only_if_enabled:true},()=>{})
              }
              array_err.push({field:f,type:"blank"})
            })
          }
          if(array_err.length > 0){
            // For now only is checking if is blank, so will not check the type
            var error_field_names = array_err.map(m=>{return m.field.label}).join("/")
            vm.$notify({
              title: error_field_names + ' は入力必須項目になります。', //  'Check the field with incorrect content.',
              type: 'error',
              duration: 10000
            });
          }else{
            return cb(array_err);
          }
        })

        // vm.fieldList.array.forEach(f=>{

        // })

    },
    commonSaveIfNotBlank(vm, mode,options, field_name_arr,cb=()=>{}){
      var has_error = false
      vm.$notify({clean:true});
      field_name_arr.forEach(field_id=>{

        var temp_val = "";
        if(has_error == false){
          if(vm.is_new){
            temp_val =  vm.$store.state[vm.stateCurrentEditing][field_id]
          }else{
            temp_val = vm.$store.state[vm.stateCurrentEditing][field_id] 
            if(typeof temp_val == "undefined"){
              // it is OK to ignore it
              temp_val = "-";
            }
          }
          var val = _.trim(utils.if_null(temp_val,""))
          if(val.length < 1){
            vm.$notify({
                title: '入力されていない項目があります。',
                //text: ",
                type: 'error',
                duration: 10000
            });
            has_error = true;
          }
        }
      })
      if(has_error == false){
        vm.read_only = false;
        vm.commonSaveInfo(vm, mode,options,cb );
      }else{
        return  cb('入力されていない項目があります。')
      }
    },
    commonSaveInfo: (vm, mode,options = {}, cb=()=>{}) => {
      debug_pageCommon("save info", vm.values, vm.$store.state[vm.stateCurrentEditing])
      if(_.find(vm.validationRestrictionList,{active:true})){
        vm.$notify({clean:true});
        vm.$notify({
          title: 'エラーが表示されている項目を修正してください', //  'Check the field with incorrect content.',
          type: 'error',
          duration: 5000
        });
        return;
      }

      vm.validationRestrictionList = {};
      var changes = utils.copyAllowed(mode, vm.$store.state[vm.stateCurrentEditing])
      if (changes == false || changes == null || typeof changes == "undefined" || Object.keys(changes).length == 0) {
        if(options.ignore_empty_changes == true){
          return cb()
        }
        vm.$notify({
          title: '保存する変更はありません。',
          type: 'error',
          duration: 5000
        });
      } else {
        var last_changed_uuid = (vm.$store.state[vm.stateCurrentRow].last_changed_uuid || "")+"";
        if(last_changed_uuid.length > 0){
          changes.last_changed_uuid = last_changed_uuid;
        }
        var method_name = '/set/'
        if(options.use_transaction  == true){
          method_name = '/t_set/'
        }
        vm.$ajax.post('/' + mode + method_name+ vm.$store.state[vm.stateCurrentRow].seq_id, {
          changes,
          check_field_size:true,
          form_confirmation:vm.form_confirmation||{},
          from_edit_form: options.from_edit_form == true,
          overwrite_changed_fields:options.overwrite_changed_fields == true,
          approval_id:options.approval_id||null,
          seq_id: vm.$store.state[vm.stateCurrentRow].seq_id
        }, (err, result, error_code) => {
          debug_pageCommon("common SaveInfo",{err, result})
          vm.$notify({clean: true});
          if (err) {
            setTimeout(()=>{
              vm.$notify({clean: true});
              var title = "予期しないエラーが発生し、登録が行えません";
              if(err && err.err_type == "invalid_size"){
                var obj = {
                  title: title,
                  text:err.err,
                  type: 'error',
                  duration: 10000
                }
              }else{
                if(err && err.indexOf("::") == 0){
                  title = err.replace("::","");
                  err = ""
                }
                vm.$notify({clean: true});
                var obj = {
                  title: title,
                  text:err,
                  type: 'error',
                  duration: 10000
                }
              }
              console.log ("common SaveInfo message",obj)
              vm.$notify(obj);
            },50)

          } else {
            if (vm.selected_row == Number.MAX_SAFE_INTEGER) {
              if(typeof result.seq_id != "undefined"){
                vm.refreshNewRow(result,mode);
              }else{
                vm.refreshNewRow(result.data,mode);
              }
            } else {
              vm.$store.state[vm.stateCurrentRow] = result.data;
              if(vm.gridOptions){
                vm.refreshRow(result.data);
              }
            }
            //   var title = "保存しました!"
            //if(data[0].qty != 0){
            //if(vm.table && vm.table.indexOf("master_user") > -1){
               var title = "編集が完了しました!"
              if(vm.is_new == true){
               title = "新規登録が完了しました!"
              }
            // }
           // }
            vm.btnSetReadOnly(true)
            vm.$notify({
              title: title,
              type: 'success',
              duration: 2000
            });
            vm.commonSetStyleForChangedFields(result.data);
          }
          cb(err, result.data || result);
        })

      }
    },
    commonDelete:(vm, cb=false) =>{
      console.log("commonDelete", vm.api_name)
      vm.$ajax.post('/' + vm.api_name + '/delete/', {
        seq_id: vm.$store.state[vm.stateCurrentRow].seq_id,
        seq_id_match3: vm.$store.state[vm.stateCurrentRow].seq_id * 3
      }, (err, result, error_code) => {
        vm.$notify({clear:true});
        if (err) {
          var err_msg = "ファイルの削除に失敗しました。"
          if(err.indexOf("::") == 0){
            err_msg = err.replace("::","")
          }
          vm.$notify({
            title: err_msg,
            type: 'error',
            duration: 10000
          });
        } else {
          if(cb== false){
            vm.backToList();
          }else{
            return cb(err,result,vm);
          }
        }
      })
    },
    commonDeleteArr:(vm,arr,cb) =>{
      if(Array.isArray(arr) == false || arr.length < 1){
        return;
      }
      arr = _.uniq(arr)
      console.log("commonDeleteArr", vm.api_name)
      vm.$notify({clear:true});
      vm.$ajax.post('/' + vm.api_name + '/delete_arr/', {
        array: arr,
        array_match3: arr.length * 3
      }, (err, result, error_code) => {
        if (err) {
          var err_msg = "ユーザの削除に失敗しました。削除するユーザを対象に申請されている情報がある可能性があります。"
          if(err.indexOf("::") == 0){
            err_msg = err.replace("::","")
          }
          vm.$notify({
            title: err_msg,
            type: 'error',
            duration: 10000
          });
        } else {
          vm.gridOptions.api.purgeInfiniteCache();
          vm.countRows("commonDeleteArr");
          cb();
        }
      })
    },
    getEditingOrCurrentRow: (state,field_name)=>{

        if(typeof state[this.stateCurrentEditing][field_name] == 'undefined'){
          return _.get(state[this.stateCurrentRow],field_name,"")
        }else{
          return _.get(state[this.stateCurrentEditing],field_name,"")
        }
    }

  },
  beforeDestroy() {
    debug_pageCommon("COMMON beforeDestroy ", this.api_name, this.stateCurrentEditing)
    this.$store.state[this.stateCurrentEditing] = {};
  },
}



// WEBPACK FOOTER //
// ./src/mixins/mixin_page_common.js